import { createAction } from "typesafe-actions";
import { RequestState } from "../constants/request-state";
import { Portfolio } from "../types/portfolio/Portfolio";
import { BwicStatus } from "../types/enums/BwicStatus";
import { TPositionColor } from "./push.bwic.actions";

const request = createAction('entities/portfolio-list/Request',
    resolve => (parseQueryString?: boolean) => resolve({ parseQueryString })
);
const requestResult = createAction('entities/portfolio-list/RequestResult',
    resolve => (requestResult: RequestState, result: Portfolio[] = []) =>
        resolve({ requestResult, result })
);
const resetEntities = createAction('entities/portfolio-list/Reset');
const colorDistributionSend = createAction('entities/portfolios-list/PublicColors',
    resolve => (data: { colors: TPositionColor[], bwicReferenceName: string, historyAction: {} }) => resolve({ data })
);
const bwicStatusChanged = createAction('entities/portfolio-list/BwicStatusChange',
    resolve => (data: { bwicStatus: BwicStatus, bwicReferenceName: string, historyAction: {} }) => resolve({ data })
);
const updateSendAlertState = createAction(
    'entities/portfolio-list/UpdateSendAlertState',
    resolve =>
        (
            sendAlertState: {
                portfolioId: number;
                bwicAlert?: boolean;
                dealersInventoryAlert?: boolean;
                cleansingNoticeAlert?: boolean;
                issuanceMonitorAlert?: boolean;
                outOfRiPeriodAlert?: boolean;
                outOfNcPeriodAlert?: boolean;
                rollerDeadlineAlert?: boolean;
            }[],
        ) =>
            resolve({ sendAlertState }),
);

const deletePortfolio = createAction('entities/portfolio-list/DeletePortfolio',
    resolve => (portfolioId: number) => resolve({ portfolioId }));

const reset = createAction('entities/portfolio-list/Reset');

export const portfolioListActions = {
    request,
    requestResult,
    resetEntities,
    colorDistributionSend,
    bwicStatusChanged,
    updateSendAlertState,
    deletePortfolio,
    reset
}
